function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import Chart from 'react-apexcharts';
import formatConditional from './formatConditional';
export default function HorizontalBarChart(_ref) {
  let {
    data,
    dataName,
    formatTooltip = false
  } = _ref;
  const currencyFormatter = window.MARKET_CONSTANTS.CURRENCY_FORMATTER;
  const seriesData = data.map(singleBarData => _objectSpread(_objectSpread({}, singleBarData), {}, {
    x: singleBarData.label,
    y: singleBarData.value
  }));
  const series = [{
    name: dataName,
    data: seriesData
  }];
  const conditionalFormat = value => formatConditional(value, formatTooltip, currencyFormatter);
  const options = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        horizontal: true
      }
    },
    tooltip: {
      y: {
        formatter: conditionalFormat
      }
    },
    dataLabels: {
      enabledOnSeries: [0],
      style: {
        colors: ['#00aeef'],
        fontFamily: 'Franklin Gothic Book, sans-serif',
        fontSize: '16px'
      },
      formatter: conditionalFormat
    },
    xaxis: {
      labels: {
        style: {
          colors: '#666E7E',
          fontSize: '12px',
          fontWeight: 'bold',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        },
        formatter: conditionalFormat
      }
    },
    yaxis: {
      type: 'category',
      labels: {
        style: {
          colors: '#666E7E',
          fontSize: '14px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        }
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: series,
    type: "bar",
    height: "290px"
  }));
}